import React from 'react';

// @ts-ignore
const { Consumer, Provider } = React.createContext();

export const ThemeConsumer = Consumer;
export const ThemeProvider = Provider;
